module.exports = __webpack_public_path__ + "img/d730a27.png";